import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

import type { BlockRendererMapping } from "../BuilderUI.types";
import { Renderer } from "./Renderer";

export interface BlockRendererProps {
  block: BaseBlock;
  components: BlockRendererMapping;
}

export const BlockRenderer = ({ block, components }: BlockRendererProps) => (
  <Renderer block={block} components={components} />
);
